import { render, staticRenderFns } from "./sp-chart.vue?vue&type=template&id=b1c8a4b0"
import script from "./sp-chart.vue?vue&type=script&lang=js"
export * from "./sp-chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports